'use client';

import { useEffect, useRef } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { logger } from '@/lib/logger';

/**
 * Emite eventos { category: 'router', event: 'navigate' } cada vez que el
 * usuario navega entre paths. Se monta una sola vez en el provider raiz.
 *
 * El primer render emite navigate con from=null para registrar entry-point
 * de la sesion.
 *
 * No renderiza nada — es un side-effect puro.
 */
export default function RouteLogger() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const previousPathname = useRef<string | null>(null);

  useEffect(() => {
    const search = searchParams?.toString() ?? '';
    const from = previousPathname.current;
    const to = pathname ?? '';

    // Evitar emit duplicado si el efecto se re-ejecuta sin cambio real.
    if (from === to) return;

    logger.log({
      category: 'router',
      event: 'navigate',
      meta: {
        from: from ?? '',
        to,
        search,
      },
    });

    previousPathname.current = to;
  }, [pathname, searchParams]);

  return null;
}
